import { Box, SxProps } from '@mui/material';
import { useEffect, useRef } from 'react';

interface Props {
	sx?: SxProps;
	loading: boolean;
	onAddToCartProductDetailsTour: (timeout?: number) => void;
	onFinishProductDetailsTour: () => void;
}

export const HeaderMiniCartTourStart: React.FC<React.PropsWithChildren<Props>> = ({
	children,
	sx,
	loading,
	onAddToCartProductDetailsTour,
	onFinishProductDetailsTour,
}) => {
	const executeTourRef = useRef(false);

	useEffect(() => {
		if (loading) {
			return;
		}

		if (!executeTourRef.current) {
			onAddToCartProductDetailsTour(0);
			executeTourRef.current = true;
		}
	}, [onAddToCartProductDetailsTour, loading]);

	return (
		<Box id="header-open-cart" sx={sx} onClick={onFinishProductDetailsTour}>
			{children}
		</Box>
	);
};
